.tableControlWrapper {
  padding-top: var(--via-space-200);
  margin-bottom: var(--via-space-800);
}
